/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-props-no-spreading */
import React, { FC as ReactFC } from 'react';

import BlockUi from 'react-block-ui';
import * as intl from 'react-intl-universal';
import {
  Button,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from 'reactstrap';

import RecoveryCodeContainer from 'shared/components/recovery-code-container/RecoveryCodeContainer';
import Status from 'shared/enums/Status';
import successAnimation from 'shared/static/img/animations/success.gif';

import styles from './mfaEnabledModal.module.scss';
import MfaEnabledModalProps from './MfaEnabledModalProps';

const MfaEnabledModal: ReactFC<MfaEnabledModalProps> = (
  props: MfaEnabledModalProps
) => {
  const { isOpen, recoveryCodes, status, onToggle, onContinue } = props;

  return (
    <Modal
      size="md"
      isOpen={isOpen}
      toggle={onToggle}
      backdrop="static"
      centered
      autoFocus={false}
      trapFocus
      keyboard={false}
      id="warningPromptTarget"
    >
      <BlockUi tag="div" blocking={status === Status.Loading}>
        <ModalHeader toggle={onToggle} className="border-0 pt-4 pb-0" />
        <ModalBody className="pt-0">
          <Col xs="12">
            <Row className="d-flex align-items-center justify-content-center mb-3">
              <img
                src={successAnimation}
                alt="Success"
                className={styles.anim}
              />
            </Row>
            <Row className="d-flex align-items-center justify-content-center mb-3 text-20-bold">
              {intl.get('LBL_MFA_METHODS_ENABLED_MODAL_TITLE')}
            </Row>
            {recoveryCodes && recoveryCodes.length > 0 && (
              <>
                <Row className="mb-3">
                  <span className="text-14-light">
                    {intl.get('LBL_MFA_METHODS_ENABLED_MODAL_DESCRIPTION')}
                  </span>
                </Row>
                <Row className="d-flex flex-column align-items-center">
                  <RecoveryCodeContainer recoveryCodes={recoveryCodes} />
                </Row>
              </>
            )}
          </Col>
        </ModalBody>
        <ModalFooter className="p-3">
          <Col xs="12" className="d-flex justify-content-center">
            <Button
              color="primary"
              onClick={onContinue}
              className="d-flex justify-content-center w-100"
            >
              {intl.get('BTN_MFA_CONTINUE')}
            </Button>
          </Col>
        </ModalFooter>
      </BlockUi>
    </Modal>
  );
};

export default MfaEnabledModal;
